import "element-ui/lib/theme-chalk/index.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "@/assets/styles/index.scss"; // global css
import "./middleware";

import * as filters from "./utils/filters";

import { i18n, loadMessages } from "./utils/i18n";

import App from "./App.vue";
import ElementUI from "element-ui";
import Vue from "vue";
import locale from "element-ui/lib/locale/lang/vi";
import router from "./router";
import store from "./store";
import vClickOutside from "v-click-outside";
import VueExcelXlsx from "vue-excel-xlsx";
import tinymce from "tinymce/tinymce";
import Grid from "vue-js-grid";

import "tinymce/themes/silver";
import "tinymce/icons/default";
import "tinymce/plugins/lists";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/autoresize";
import "tinymce/plugins/quickbars";
import "tinymce/plugins/advlist";
import "tinymce/plugins/autolink";
import "tinymce/plugins/charmap";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/code";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/print";
import "tinymce/plugins/preview";
import "tinymce/plugins/anchor";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/table";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/help";
import "tinymce/plugins/media";
import "tinymce/plugins/paste";
import "tinymce/skins/ui/oxide/skin.css";
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.css";
import "tinymce/skins/ui/oxide/content.min.css";

// Initialize the app
tinymce.init({});

Vue.use(ElementUI, { locale });
Vue.use(vClickOutside);
Vue.use(VueExcelXlsx);
Vue.use(Grid);

// I18n
const { context, messages } = loadMessages();

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

// Hot updates
if (module.hot) {
  module.hot.accept(context.id, () => {
    const { messages: newMessages } = loadMessages();

    Object.keys(newMessages)
      .filter((locale) => messages[locale] !== newMessages[locale])
      .forEach((locale) => {
        messages[locale] = newMessages[locale];
        i18n.setLocaleMessage(locale, messages[locale]);
      });
  });
}
